import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import SideBar from '../common/sideBar';
import { history } from '../../../history/history';
import http from '../../../util/http';
import Pagination from '../common/Pagination';
import ReactAudioPlayer from 'react-audio-player';
import Drag from './dragNdDropaudiobrief';
import HeaderAdminpanel from '../common/HeaderAdminpanel';

// import { endPoints } from '../../../../config';
// import NoData from '../../common/NoData';
// import { CommonModelImpl } from '../../../admin/common/CommonModel';
// import { axiosInstnace as Axios } from '../../../../util/util';



class ViewAudiolist extends Component {
  constructor(props) {
    super(props);
    this.state = {      
      uploadAudio: "drag_nd_drp",   
      uploadedAudio: [],
      submit:null  ,
      fileName : null  ,
      fileSizeWithLimit:null  ,
      fileSize:null  ,
      option: null  
    }
  };




serverCalls= async(url, data)=> {
  const response= await http.post(url, data);
  if(response && response.data.statusCode== 200) {
      this.componentDidMount();
  }
  else {
      this.props.showError(response? response.data.message: "Something is wrong");
  }
}

//Redirect to route bassed on path
goToRoute = (name, data, path) => {
history.push(path, { [name]: data });
}

//Upload a file
 getUploadedFile = files => {    
  var size = bytesToSize(files.size);    
  setFileSizeWithLimit(size); 
  handleuploadedAudio(files);
  handleFileName(files.name);
  handleFileSize(files.size);
  }


   // Show file size in bytes
    bytesToSize = (bytes, decimals=2) => {
    var sizes = ['Bytes', 'KB', 'MB', 'GB'];
    if(bytes == 0) return '0 bytes';
    var dm = decimals < 0 ? 0 : decimals;
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return parseFloat((bytes / Math.pow(1024, i)).toFixed())+ ' ' + sizes[i];
  }


   //Remove a file
   removeFile = () => {   
    handleuploadedAudio(undefined);
    handleFileSize("");
    handleFileName("");  
  }

   handleChange = event =>{
    console.log(event.target.value);
    handleuploadedAudio(event.target.value);
  }


 

  render() {
    return (      
      <div className="dashboardContainer">

         <HeaderAdminpanel/>

        <div className="dashboardContainer-inner">
              <section id="sidebar">
                 <SideBar />          
                </section>

          <section id="dashboard-rightContainer" className="dashboard-manageSales" >

            <div className="container-head">
              <div className="dashboard-breadcrumb">
              Audio Management | Audio List |<span className="breadcrumb-active fct-breadcrumb">UPLOAD Audio</span>
              </div>

            <div className="view-btn_wrapper marRgt10px">
              <button className="viewdetail_back"
                      onClick={() => this.goToRoute('', null, '/admin/audioadminmanagment/audiomanagment')}>BACK</button>
            </div>
            </div>

             {/* {props.campaign.bigFmAudio &&  */}
             <div>   

             <table className="table table-striped master-table">
                                <thead>
                                <tr>
                                    {/* <th>S.NO</th> 
                                    <th>VERSION.NO</th>  */}
                                    <th>Upload AUDIO</th> 
                                    <th>Submit AUDIO</th> 
                                    <th>NEW STATUS</th> 
                                </tr>
                                </thead>
                                <tbody> 

                                <div className="detailfile_btns">
                               <div className="upload-btn-wrapper">
                              <button className="btn">DRAG</button>
                              <input type="file" name="gst_Certificate_file" onChange={this.getUploadedFile}
                               ></input>
                            </div>
                          </div>


                                  <td>
                                  {!this.uploadedAudio && this.option && <div className={this.uploadAudio } >
                          <h6>Upload Audio File</h6>
                          <Drag getUploadedFile={this.getUploadedFile}  />                          
                        </div>}
                        {this.uploadedAudio && this.option && <div className="upload_file">
                          <h6>Uploaded Audio Brief File</h6>
                          <div>
                            <div className="audio_img"> <img src="../../assets/images/song.svg" /></div>
                            <div className="file_desc">
                              <div className="file_name_size">
                                <div className="file_name">{this.uploadedAudio.path}</div>                             
                              </div>
                    <div className="remove_file"><span className="filesize">{this.fileSizeWithLimit}</span><a onClick={this.removeFile}> REMOVE</a></div>
                            </div>
                          </div>
                        </div>}
                         </td>  


                                    {/* <td>{props.audiostatus}</td>  */}
                                </tbody>
                            </table>
                        </div>
                        
           
        </section>
            </div>
           </div>   
);
};
};

export default connect( null,{ })(ViewAudiolist);


// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/ViewAudiolist.jsx